import { isRetinaDevice } from '../../../../../../../../utils/browser';
import { useUtils } from '../../../../../../../UtilsProvider';

const buildVideoSrcUrl = (videoName: string): string => {
  const retinaSuffix = isRetinaDevice ? '-@2x' : '';
  return `${videoName}${retinaSuffix}.mp4`;
};

export const useVideoSrcUrl = (source = ''): string => {
  const {
    serviceTopology,
    media: { getMediaUrl },
  } = useUtils();

  const videoName =
    source.includes('videobox') || source.includes('textMask')
      ? getMediaUrl(source)
      : `${serviceTopology.editorAssetsBaseUrl}video/${source}`;

  return buildVideoSrcUrl(videoName);
};
